import React, { useState, useEffect, createContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './pages/AdminLogin';
import Dashboard from './pages/Dashboard';
import EnquiryInbox from './pages/EnquiryInbox';
import EnquiryDetail from './pages/EnquiryDetail';
import QuotationList from './pages/QuotationList';
import GenerateQuotation from './pages/GenerateQuotation';
import ViewQuotation from './pages/ViewQuotation';
import EditQuotation from './pages/EditQuotation';
import QuotationTemplates from './pages/QuotationTemplates';
import BrowseProducts from './pages/BrowseProducts';
import ProductList from './pages/ProductList';
import AddProduct from './pages/AddProduct';
import EditProduct from './pages/EditProduct';
import ProductBulkImport from './pages/ProductBulkImport';
import MarketingControls from './pages/MarketingControls';
import ProductImageEnhancer from './pages/ProductImageEnhancer';
import AddCategory from './pages/AddCategory';
import EditCategory from './pages/EditCategory';
import CategoryList from './pages/CategoryList';
import './App.css';

export const AuthContext = createContext();

function App() {
  const [token, setToken] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    const storedAdmin = localStorage.getItem('admin');
    
    if (storedToken) {
      setToken(storedToken);
      if (storedAdmin) {
        try {
          setAdmin(JSON.parse(storedAdmin));
        } catch (e) {
          console.error('Failed to parse admin data');
        }
      }
    }
    setLoading(false);
  }, []);

  const handleLogin = () => {
    const storedToken = localStorage.getItem('token');
    const storedAdmin = localStorage.getItem('admin');
    
    if (storedToken) {
      setToken(storedToken);
      if (storedAdmin) {
        try {
          setAdmin(JSON.parse(storedAdmin));
        } catch (e) {
          console.error('Failed to parse admin data');
        }
      }
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('admin');
    setToken(null);
    setAdmin(null);
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ token, admin, logout: handleLogout }}>
      <Router>
        <Routes>
          <Route 
            path="/login" 
            element={!token ? <AdminLogin onLoginSuccess={handleLogin} /> : <Navigate to="/dashboard" />} 
          />
          
          {/* Protected Routes */}
          <Route 
            path="/dashboard" 
            element={token ? <Dashboard /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/enquiries" 
            element={token ? <EnquiryInbox /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/enquiries/:id" 
            element={token ? <EnquiryDetail /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/quotations" 
            element={token ? <QuotationList /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/quotations/new" 
            element={token ? <GenerateQuotation /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/quotations/:id" 
            element={token ? <ViewQuotation /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/quotations/:id/edit" 
            element={token ? <EditQuotation /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/quotation-templates" 
            element={token ? <QuotationTemplates /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/products" 
            element={token ? <ProductList /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/products/browse" 
            element={token ? <BrowseProducts /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/products/new" 
            element={token ? <AddProduct /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/products/:id/edit" 
            element={token ? <EditProduct /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/products/bulk-import" 
            element={token ? <ProductBulkImport /> : <Navigate to="/login" />} 
          />
          <Route
            path="/marketing-controls"
            element={token ? <MarketingControls /> : <Navigate to="/login" />}
          />
          <Route
            path="/products/image-enhancer"
            element={token ? <ProductImageEnhancer /> : <Navigate to="/login" />}
          />
          <Route 
            path="/categories/new" 
            element={token ? <AddCategory /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/categories" 
            element={token ? <CategoryList /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/categories/:id/edit" 
            element={token ? <EditCategory /> : <Navigate to="/login" />} 
          />
          
          <Route path="/" element={<Navigate to={token ? "/dashboard" : "/login"} />} />
        </Routes>
      </Router>
    </AuthContext.Provider>
  );
}

export default App;
